export default __webpack_public_path__ + "static/media/AvenirNext.fa81bf92.ttc";